import { Component, Input, forwardRef, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-campo-texto',
  standalone: true,
  imports: [],
  templateUrl: './campo-texto.component.html',
  styleUrl: './campo-texto.component.css',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CampoTextoComponent), multi: true }
  ]
})
export class CampoTextoComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() placeholder = '';
  @Input() erro = '';
  @Input() disabled = false;
  @Input() tipo: 'texto' | 'senha' = 'texto';
  @Input() somenteLeitura = false;
  @Input() autocomplete = 'off';

  valor = '';
  tocado = false;
  senhaVisivel = signal(false);

  private onChange: (value: string) => void = () => { /* */ };
  private onTouched: () => void = () => { /**/ };

  writeValue(value: string): void {
    this.valor = value ?? '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get tipoInputAtual(): string {
    if (this.tipo !== 'senha') {
      return 'text';
    }
    return this.senhaVisivel() ? 'text' : 'password';
  }

  alternarSenhaVisivel() {
    this.senhaVisivel.update(v => !v);
  }

  aoDigitar(valor: string) {
    this.valor = valor;
    this.onChange(valor);
  }

  aoTocar() {
    this.tocado = true;
    this.onTouched();
  }
}
